// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3M0Ab","box":"WorkspacesBox_box__3USyY","node":"WorkspacesBox_node__1zHAP"};